export class LocalStorageKeys {
	static get TOKEN() {
		return "token";
	}
}
